/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { jwtDecode } from 'jwt-decode';
import useApi from 'hooks/useApi';
import { get } from 'lodash';
import ServerSideTableFooter from 'components/common/advance-table/ServerSideTableFooter';
import ServerSideTable from 'components/common/advance-table/ServerSideTable';
import ServerSideTableWrapper from 'components/common/advance-table/ServerSideTableWrapper';
import CustomSpinner from 'components/common/CustomSpinner';
import { getinfectionReport } from 'api/endpoints/CropInfection';
import { getDiseaseList } from 'api/endpoints/Disease';
import { getPestList } from 'api/endpoints/Pest';
import {
  getdynamicCollapseReport,
  getDynamicReportdata
} from 'api/DynamicReportApi';
import MultiSelect from 'components/common/MultiSelect';
import Select from 'react-select';
import { Col } from 'react-bootstrap';
import RangeDatePicker from 'screens/common/RageDatePicker';
import DynamicModal from './DynamicModal';
import { getCropReport } from 'api/endpoints/CropCalender';
import { getCropList } from 'api/endpoints/Crop';
import { getTenantFromToken } from 'utils/routeUtils';

const DyanamicCollapseReportTable = ({
  showFilter,
  setExportData,
  dropdownFilter,
  cropFilter,
  responsive,
  cardTittles,
  globalSearchFilter,
  dateRangePicker,
  apiPath,
  forInfection,
  forCropCalendar,
  setExportKey,
  service
}) => {
  const tenant = getTenantFromToken();

  const getDynamicReportApi = useApi(
    forInfection
      ? getinfectionReport
      : forCropCalendar
      ? getCropReport
      : getdynamicCollapseReport
  );
  const getPestListApi = useApi(getPestList);
  const getDiseaseListApi = useApi(getDiseaseList);
  const getCroplistApi = useApi(getCropList);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [selectedDisease, setSelectedDisease] = useState([]); // State to store selected options
  const [selectedPest, setSelectedPest] = useState([]); // State to store selected options
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCrop, setSelectedCrop] = useState([]);
  const [diseaseList, setDiseaseList] = useState([]);
  const [pestList, setPestList] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [paginationFilter, setPaginationFilter] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [filteredTableData, setFilteredTableData] = useState(null); // Data to display
  const [pageSize, setPageSize] = useState(25);
  const [pageIndex, setPageIndex] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [canNextPage, setCanNextPage] = useState(true);
  const [filters, setFilters] = useState({});
  const [globalfilters, setGlobalFilters] = useState({
    search_text: ''
  });
  const [cursor, setCursor] = useState(0);
  const [globalSearch, setGlobalSearch] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [showButtonModal, setShowButtonModal] = useState(false);
  const [selectedModalData, setSelectedModalData] = useState(null);

  useEffect(() => {
    getPestListApi.request(tenant);
    getDiseaseListApi.request(tenant);
    getCroplistApi.request(tenant);
  }, []);

  useEffect(() => {
    let PestList = get(getPestListApi, 'data.results', []);
    let DiseaseList = get(getDiseaseListApi, 'data.results', []);
    let CropList = get(getCroplistApi, 'data.results', []);
    setDiseaseList(DiseaseList);
    setPestList(PestList);
    setCropList(CropList);
  }, [getPestListApi.data, getDiseaseListApi.data, getCroplistApi.data]);

  useEffect(() => {
    let limit = pageSize;
    let cursor = pageIndex * pageSize;
    let diseaseIds = selectedDisease.map(i => i.value);
    let pestIds = selectedPest.map(i => i.value);
    let cropIds = selectedCrop.map(i => i.value);
    setCursor(cursor);
    if (!showButtonModal) {
      getDynamicReportApi.request({
        cursor,
        limit,
        tenant,
        diseaseIds,
        pestIds,
        cropIds,
        startDate,
        endDate,
        apiPath,
        service,
        search_text: globalfilters.search_text
      });
    }
  }, [
    pageIndex,
    globalfilters,
    pageSize,
    selectedDisease,
    selectedPest,
    selectedCrop,
    startDate,
    endDate,
    showButtonModal
  ]);

  useEffect(() => {
    setTableData([]);
    const tabledata = get(getDynamicReportApi, 'data.results', []);
    const exportKey = get(getDynamicReportApi, 'data.results.export_key', '');
    setExportKey(exportKey);
    setRowCount(get(getDynamicReportApi, 'data.results.total', 0));
    setTotalRowCount(get(getDynamicReportApi, 'data.results.total', 0));
    setCanNextPage(tabledata.remaining_records > 0);
    setTableData(tabledata.data);
    setFilteredTableData(tabledata.data);
    setExportData(tabledata.data);
  }, [getDynamicReportApi.data]);

  const flattenedData = tableData;

  const excludeKeys = new Set([
    'farm_id',
    'id',
    'more',
    'extra',
    'modalButtons'
  ]);
  const columns =
    flattenedData?.length > 0
      ? [
          ...Object.keys(flattenedData[0])
            .filter(key => !key.includes('_color') && !excludeKeys.has(key))
            .map(key => {
              const colorKey = `${key}_color`;
              return {
                Header: key
                  .replace(/_/g, ' ')
                  .replace(/(^\w|\b\w(?![^()]*\)))/g, c => c.toUpperCase()),
                accessor: row => row[key], // use accessor function to support any key
                id: key, // required when using function accessor
                Cell: ({ value, row }) => {
                  let displayValue =
                    typeof value === 'object' && value !== null
                      ? ' - '
                      : value === 'NA' || value === null
                      ? ' - '
                      : value;

                  return (
                    <span
                      style={{ color: row.original[colorKey] || 'inherit' }}
                    >
                      {displayValue || ''}
                    </span>
                  );
                }
              };
            })
        ]
      : [];

  const handlePageChange = newPageIndex => {
    setPageIndex(newPageIndex);
  };

  const handlePageSizeChange = newPageSize => {
    setPageSize(newPageSize);
    setPageIndex(0);
    setTableData(null);
  };

  // Handle filter changes for specific columns
  const handleFilterChange = (columnId, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [columnId]: value
    }));
  };

  useEffect(() => {
    // Handle case when filters is undefined or null
    if (!tableData || Object.keys(filters ?? {}).length === 0) {
      setFilteredTableData(tableData); // Reset to original if no filters
      return;
    }

    const filtered = tableData.filter(row =>
      Object.entries(filters).every(([columnId, filterValue]) => {
        const filterValueLower = filterValue.toLowerCase();
        if (row[columnId] === null || row[columnId] === undefined) return false;
        // Check if the value is an array (like weather_parameters, risk_ranges)
        if (typeof row[columnId] === 'object') {
          // For array fields, check if any element in the array contains the filter value
          return Object.values(row[columnId]).some(value =>
            value.toString().toLowerCase().includes(filterValueLower)
          );
        }
        // Otherwise, handle non-array fields (strings, numbers, etc.)
        const cellValue = row[columnId]?.toString().toLowerCase() || '';
        return cellValue.startsWith(filterValueLower);
      })
    );

    setExportData(filtered);
    setFilteredTableData(filtered);
    const hasValidFilter = Object.values(filters).some(
      value => value !== null && value !== ''
    );
    hasValidFilter ? setPaginationFilter(true) : setPaginationFilter(false);
    showFilter && hasValidFilter
      ? setRowCount(filtered?.length)
      : setRowCount(totalRowCount);
  }, [filters, tableData, showFilter]);

  const handleGlobalFilterChange = (columnId, value) => {
    setGlobalFilters(prevFilters => ({
      ...prevFilters,
      [columnId]: value
    }));
  };

  const handleGlobalSearch = e => {
    const searchValue = e.target.value;
    handleGlobalFilterChange('search_text', searchValue);
    setGlobalSearch(searchValue);
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      // overflowY: 'scroll',
      // whiteSpace: 'nowrap',
      // textOverflow: 'ellipsis',
      // height: '40px',
      minHeight: '80px',
      backgroundColor: 'blue'
    }),
    valueContainer: provided => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      textOverflow: 'ellipsis',
      // maxWidth: 'calc(100% - 8px)',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      maxWidth: '200px',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      // background: 'red',
      maxHeight: '90px'
    }),

    multiValue: provided => ({
      ...provided,
      // display: 'none',
      backgroundColor: 'yellow',
      height: 'fit-content'
    }),
    multiValueLabel: provided => ({
      ...provided
      // display: 'none'
      // backgroundColor: 'green',
      // height: '20px'
    })
  };

  const formatDate = date => {
    const d = new Date(date);
    const day = ('0' + d.getDate()).slice(-2);
    const month = ('0' + (d.getMonth() + 1)).slice(-2); // Month is zero-based
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (start, end) => {
    if ((start && end) || (start == '' && end == '')) {
      const formattedStartDate = start ? formatDate(start) : '';
      const formattedEndDate = end ? formatDate(end) : '';
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
    }
  };

  const handleAction = (action, rowData) => {
    if (action === 'viewData') {
      const modalData = rowData; // You can modify this to extract specific data if needed
      setShowButtonModal(true); // Show the modal for the button action
      setSelectedModalData(modalData); // Store the data to be displayed in the modal
    }
  };

  return (
    <>
      <ServerSideTableWrapper
        key={`${pageSize}-${pageIndex}`}
        columns={columns}
        data={filteredTableData || flattenedData}
        pagination
        sortable
        perPage={pageSize}
        className="min-vh-50 py-5"
        stickyColumns={[]}
      >
        <div className="d-md-none mb-3">
          <button
            type="button"
            className="btn btn-outline-primary w-100"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? 'Hide Filters' : 'Show Filters'}
          </button>
        </div>
        <div
          className={`d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 ${
            showFilters ? '' : 'd-none d-md-flex'
          }`}
        >
          {globalSearchFilter ? (
            <input
              type="text"
              placeholder="Search..."
              className="form-control mb-3 mb-md-0 w-100 w-md-25"
              value={globalfilters.search_text}
              onChange={handleGlobalSearch}
            />
          ) : (
            <></>
          )}

          <div className="d-flex flex-column flex-md-row gap-3 w-100 w-md-auto">
            <div className="datepicker-wrapper flex-grow-1 flex-md-shrink-0">
              {cropFilter && (
                <Col lg={12}>
                  <Select
                    options={cropList}
                    isClearable={true}
                    placeholder="Select Crop"
                    classNamePrefix="react-select"
                    value={selectedCrop}
                    onChange={selected => setSelectedCrop(selected)}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    styles={{
                      ...customStyles,
                      control: base => ({
                        ...base,
                        minWidth: '200px', // Set min-width here
                        maxWidth: '400px', // Optional max width
                        width: '100%' // Ensure it expands to available width
                      })
                    }}
                    //   option: (provided, state) => ({
                    //     ...provided,
                    //     color: state.isDisabled ? '#d3d3d3' : '#000', // Light gray for disabled, black for enabled
                    //     fontWeight: state.isDisabled ? 'lighter' : 'bold', // Lighter font for disabled options
                    //     cursor: state.isDisabled ? 'not-allowed' : 'pointer' // Pointer cursor for enabled options
                    //   })
                    // }}
                  />
                </Col>
              )}
            </div>
            <div className="datepicker-wrapper flex-grow-1 flex-md-shrink-0">
              {dropdownFilter && (
                <Col lg={12}>
                  <Select
                    options={pestList}
                    isClearable={true}
                    placeholder="Select Pest"
                    classNamePrefix="react-select"
                    value={selectedPest}
                    onChange={selected => setSelectedPest(selected)}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    styles={{
                      ...customStyles,
                      control: base => ({
                        ...base,
                        minWidth: '200px', // Set min-width here
                        maxWidth: '400px', // Optional max width
                        width: '100%' // Ensure it expands to available width
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: state.isDisabled ? '#d3d3d3' : '#000', // Light gray for disabled, black for enabled
                        fontWeight: state.isDisabled ? 'lighter' : 'bold', // Lighter font for disabled options
                        cursor: state.isDisabled ? 'not-allowed' : 'pointer' // Pointer cursor for enabled options
                      })
                    }}
                  />
                </Col>
              )}
            </div>
            <div className="datepicker-wrapper flex-grow-1 flex-md-shrink-0">
              {dropdownFilter && (
                <Col lg={12}>
                  <Select
                    options={diseaseList}
                    isClearable={true}
                    placeholder="Select Disease"
                    classNamePrefix="react-select"
                    value={selectedDisease}
                    onChange={selected => setSelectedDisease(selected)}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    styles={{
                      ...customStyles,
                      control: base => ({
                        ...base,
                        minWidth: '200px', // Set min-width here
                        maxWidth: '400px', // Optional max width
                        width: '100%' // Ensure it expands to available width
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: state.isDisabled ? '#d3d3d3' : '#000', // Light gray for disabled, black for enabled
                        fontWeight: state.isDisabled ? 'lighter' : 'bold', // Lighter font for disabled options
                        cursor: state.isDisabled ? 'not-allowed' : 'pointer' // Pointer cursor for enabled options
                      })
                    }}
                  />
                </Col>
              )}
            </div>
            <div className="d-flex flex-column flex-md-row gap-3 w-100 w-md-auto">
              {dateRangePicker && (
                <RangeDatePicker
                  noLabel={true}
                  styleWidth={true}
                  onDateChange={handleDateChange}
                />
              )}
            </div>
          </div>
        </div>

        {/* {getFarmTableDataAPI.loading && !showFilter ? (
        <CustomSpinner />
      ) : ( */}
        {rowCount > 0 ||
        (Object.keys(filters ?? {}).length > 0 && showFilter) ? (
          <ServerSideTable
            key={`${pageSize}-${pageIndex}`}
            table
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            responsive={responsive}
            cardTittles={cardTittles}
            tableProps={{
              bordered: true,
              striped: true,
              className: 'fs--1 mb-0'
            }}
            filters={filters}
            handleFilterChange={handleFilterChange}
            showFilterRow={showFilter}
            pageIndex={pageIndex}
            pageSize={pageSize}
            cursor={cursor}
            clientSideSearch={true}
            handleAction={handleAction}
          />
        ) : (
          <h1
            className="text-center my-5"
            style={{ color: '#6c757d', fontSize: '1.5rem', opacity: 0.7 }}
          >
            {globalSearch != ''
              ? `"${globalSearch}", not found!`
              : 'No data available!'}
          </h1>
        )}
        {/* )} */}
        <div className="mt-3">
          <ServerSideTableFooter
            rowCount={rowCount}
            pageSize={pageSize}
            pageIndex={pageIndex}
            paginationFilter={paginationFilter}
            setPageSize={handlePageSizeChange}
            canPreviousPage={pageIndex > 0}
            canNextPage={canNextPage}
            nextPage={() => handlePageChange(pageIndex + 1)}
            previousPage={() => handlePageChange(Math.max(0, pageIndex - 1))}
            rowsPerPageSelection
            navButtons
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            rowsPerPageOptions={[25, 50, 100, 200]}
            handleFilterChange={handleFilterChange}
          />
        </div>
      </ServerSideTableWrapper>
      <>
        {showButtonModal && (
          <DynamicModal
            show={true}
            onClose={() => setShowButtonModal(false)}
            selectedModalData={selectedModalData}
          />
        )}
      </>
    </>
  );
};

DyanamicCollapseReportTable.propTypes = {
  data: PropTypes.array,
  deletePorjectAPI: PropTypes.object.isRequired,
  startProcessingAPI: PropTypes.object.isRequired
};

ServerSideTableWrapper.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string,
      Header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      Cell: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          value: PropTypes.func.isRequired,
          row: PropTypes.shape({
            original: PropTypes.object.isRequired
          }).isRequired
        })
      ])
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  pagination: PropTypes.bool,
  perPage: PropTypes.number
};

export default DyanamicCollapseReportTable;
